import makeFetch from "../../utils/http";
import API from "../../helpers/apiHelpers";
import axios from "axios";

export function api_logInUser(user) {
    return makeFetch(
        "authenticationTokens",
        "POST",
        {},
        JSON.stringify(user)
    );
}

export function api_signUpUser(user) {
    return makeFetch(
        "users",
        "POST",
        {},
        JSON.stringify(user)
    );
}

export function api_patchPassword(body) {
    return makeFetch(
        "passwordresettokens",
        "PATCH",
        {},
        body,
        false,
        "include",
        true
    );
}

export async function api_getUserLocation(ip) {
    const location = await axios(`https://api.ipstack.com/${ip}?access_key=${process.env.REACT_APP_IPSTACK_KEY}`).then(
        res => {
            if (res.status === 200) {
                return res.data;
            } else {
                return null;
            }
        });
    return location;
}

export function api_applyReferralCode(code) {
    return makeFetch(
        `referralCodeRequests/${code}`,
        "POST"
    );
}

export function api_getUserByID(id) {
    return makeFetch(
        `users/${id}`,
        "GET"
    );
}

export function api_getUser(id) {
    return makeFetch(
        `users/${id}`,
        "GET"
    );
}

export function api_getPartnerGifts(animalTypes, userId) {
    return makeFetch(
        "gifts",
        "GET",
        {
            animalTypes,
            userId,
        }
    );
}

export function setApiOwnerEmailGift(id) {
    return makeFetch(
        "ownerEmailGifts",
        "POST",
        {
            "partnerGiftId": id
        },
    );
}

export function api_getOwnerEmailGifts() {
    return makeFetch(
        "ownerEmailGifts",
        "GET",
    );
}

export function api_leaveFeed(reasonForLeaving) {
    return makeFetch(
        "feedbacks",
        "POST",
        {},
        JSON.stringify({
            type: "LEAVING",
            reasonForLeaving,
        })
    );
}

export function api_resendConfirmationEmail(email) {
    return makeFetch(
        "users/createConfirmationToken",
        "POST",
        {email},
    );
}

export function api_signOutUser() {
    API.clearAuth();
}

export function api_changeLeaveForm(id, body) {
    return makeFetch(
        `users/${id}`,
        "PATCH",
        {},
        JSON.stringify(body)
    );
}
